import Facts from './Facts';

export default Facts;
